import {BaseOptions} from '../../../../dialog/options/base.options';

export class AddOrUpdateAdditiveOptions extends BaseOptions {
  additive?: any;

  onInsertOrUpdateFinished() {
  }
}
